module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Cart")]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('shopping-cart-item', {
      key: item.id,
      attrs: {
        "item": item
      }
    })
  }), _vm._v(" "), _c('shopping-cart-summary'), _vm._v(" "), _c('div', {
    staticClass: "mt-1 text-xs-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.orderOnLimit
    },
    on: {
      "click": _vm.buy
    }
  }, [_vm._v(" \n      Checkout\n    ")]), _vm._v(" "), (_vm.orderOnLimit) ? _c('p', [_vm._v(" Order is over limit. ")]) : _vm._e()])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cc0604c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shop/shopping-cart/ShoppingCart.vue
// module id = 267
// module chunks = 1